/// <reference types="./selector.d.mts" />
import * as $spreadsheet from "../../../common/data/spreadsheet.mjs";
import * as $dropdown from "../../../ds/ds/components/dropdown.mjs";
import * as $outline from "../../../ds/ds/outline.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $length from "../../../sketch/sketch/css/length.mjs";
import { px, rem } from "../../../sketch/sketch/css/length.mjs";
import { Ok, toList, makeError, remainderInt, divideInt } from "../../gleam.mjs";

const FILEPATH = "src/app_config/spreadsheet/selector.gleam";

export function to_letters(n) {
  let $ = n <= 26;
  if ($) {
    let $1 = $string.utf_codepoint(64 + n);
    if (!($1 instanceof Ok)) {
      throw makeError(
        "let_assert",
        FILEPATH,
        "app_config/spreadsheet/selector",
        48,
        "to_letters",
        "Pattern match failed, no pattern matched the value.",
        {
          value: $1,
          start: 1233,
          end: 1288,
          pattern_start: 1244,
          pattern_end: 1257
        }
      )
    }
    let codepoint = $1[0];
    return $string.from_utf_codepoints(toList([codepoint]));
  } else {
    let $1 = $string.utf_codepoint(64 + (remainderInt(n, 26)));
    if (!($1 instanceof Ok)) {
      throw makeError(
        "let_assert",
        FILEPATH,
        "app_config/spreadsheet/selector",
        52,
        "to_letters",
        "Pattern match failed, no pattern matched the value.",
        {
          value: $1,
          start: 1362,
          end: 1426,
          pattern_start: 1373,
          pattern_end: 1386
        }
      )
    }
    let codepoint = $1[0];
    let codepoint$1 = $string.from_utf_codepoints(toList([codepoint]));
    return to_letters(divideInt(n, 26)) + codepoint$1;
  }
}

function spacing() {
  return $css.class$(toList([$css.gap(px(10)), $css.padding(px(10))]));
}

function label() {
  return $css.class$(
    toList([
      $css.padding_("4px 12px"),
      $css.border_radius(px(4)),
      $css.text_align("center"),
      $css.white_space("nowrap"),
      $css.flex("1"),
      $css.cursor("pointer"),
      $css.border("1px solid transparent"),
      $css.color("var(--text-color)"),
      (() => {
        let _pipe = $css.background("var(--background-color)");
        return $css.important(_pipe);
      })(),
      $css.transition("border_color 0.3s"),
      $css.font_weight("500"),
      $css.font_size(rem(0.875)),
      $css.line_height("1.25rem"),
      $css.min_width(px(120)),
      $css.hover(
        toList([
          (() => {
            let _pipe = $css.border_color("var(--text-color)");
            return $css.important(_pipe);
          })(),
          $css.background("var(--background-color)"),
        ]),
      ),
    ]),
  );
}

function success() {
  return $css.class$(
    toList([
      $css.compose(label()),
      $css.property("--background-color", "#f6ffdf"),
      $css.property("--text-color", "#b1db4b"),
    ]),
  );
}

function neutral() {
  return $css.class$(
    toList([
      $css.compose(label()),
      $css.property("--background-color", "#eaebec"),
      $css.property("--text-color", "#7e7f88"),
    ]),
  );
}

function current() {
  return $css.class$(
    toList([
      $css.compose(label()),
      $css.property("--background-color", "#eef4fe"),
      $css.property("--text-color", "#3b75ca"),
    ]),
  );
}

function bordered(class$) {
  return $css.class$(
    toList([
      $css.compose(class$),
      (() => {
        let _pipe = $css.border_color("var(--text-color)");
        return $css.important(_pipe);
      })(),
    ]),
  );
}

function input_class(selected, disabled) {
  return $css.class$(
    toList([
      $css.compose(
        (() => {
          if (selected instanceof $spreadsheet.SectionRow) {
            return bordered(current());
          } else if (selected instanceof $spreadsheet.QuestionRow) {
            return bordered(success());
          } else if (selected instanceof $spreadsheet.SubQuestionRow) {
            return bordered(success());
          } else {
            return bordered(neutral());
          }
        })(),
      ),
      $css.opacity(
        (() => {
          if (disabled) {
            return 0.4;
          } else {
            return 1.0;
          }
        })(),
      ),
    ]),
  );
}

export function row(on_select, disabled, selected) {
  return $dropdown.dropdown(
    on_select,
    toList([
      $dropdown.show_arrow(),
      $dropdown.selected(new Some(selected)),
      $dropdown.panel_class(spacing()),
      $dropdown.input_class(input_class(selected, disabled)),
      $dropdown.disabled(disabled),
    ]),
    toList([
      (() => {
        let _pipe = $dropdown.choice("Question", new $spreadsheet.QuestionRow());
        return $dropdown.with_class(_pipe, success());
      })(),
      (() => {
        let _pipe = $dropdown.choice(
          "Sub-Question",
          new $spreadsheet.SubQuestionRow(),
        );
        return $dropdown.with_class(_pipe, success());
      })(),
      (() => {
        let _pipe = $dropdown.choice("Section", new $spreadsheet.SectionRow());
        return $dropdown.with_class(_pipe, current());
      })(),
      (() => {
        let _pipe = $dropdown.choice("", new $spreadsheet.UndefinedRow());
        let _pipe$1 = $dropdown.with_icon(_pipe, $outline.line());
        return $dropdown.with_class(_pipe$1, neutral());
      })(),
    ]),
  );
}
